<script type="text/jsx">
import ParticipantsDiffPopover from '@/plans/LARGE_MEETING/component/participants-diff-popover.vue';
import planCommonMixin from '@/plans/LARGE_MEETING/mixin';
import ConfigBase from '@/components/config-base';

export default {
  name: 'ConfigBase',
  extends: ConfigBase,
  mixins: [planCommonMixin],
  components: { ParticipantsDiffPopover },
  data() {
    return {
      orderByKey: "capacity",
    };
  },
  methods: {
    mx_renderConfigDesc() {
      return <p class="opc-addon-config__main__title">
        <span>{this.configDescription}</span>
        <participants-diff-popover type={this.planType} />
      </p>;
    },
    mx_renderLicense(plan) {
      if (!plan.cartInfo.selected_number) return;
      return <li class="text-lowercase">{`${plan.cartInfo.selected_number} ${this.$t('billing.planform.unit.license')}`}</li>;
    },
  },
};
</script>
